import { Link } from "react-router-dom";

const About = (): JSX.Element => (
  <main className="page">
    <header className="header">
      <div>
        <p className="muted">About</p>
        <h1 className="title">Project Stack</h1>
        <p className="muted">
          React 18.3.1, Rspack bundling with React Compiler, TypeScript, Redux Toolkit,
          Redux Saga, React Router, and ESLint.
        </p>
      </div>
      <Link
        to="/"
        className="pill"
      >
        Go Home
      </Link>
    </header>
    <section className="card">
      <ul className="list">
        <li>Rspack configured with Babel + React Compiler plugin.</li>
        <li>Redux store powered by Redux Toolkit and Redux Saga middleware.</li>
        <li>React Router v6 for client-side navigation.</li>
        <li>ESLint with TypeScript, React, and Prettier compatibility.</li>
      </ul>
    </section>
  </main>
);

export default About;
